import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/radar", label: "Radar" },
  { to: "/spc", label: "SPC" },
  { to: "/research", label: "Research" },
  { to: "/chat", label: "Chat" },
  { to: "/shop", label: "Shop" },
  { to: "/submit-photo", label: "Submit Photo" },
  { to: "/apply", label: "Apply" },
  { to: "/events", label: "Events" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#0A0A0A]/80 backdrop-blur-md border-b border-white/5"
    >
      <div className="container-vg flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="relative inline-flex items-center justify-center w-9 h-9 border border-yellow-400/40 bg-yellow-400/5">
            <Zap className="w-5 h-5 text-yellow-400" strokeWidth={2.5} />
            <span className="absolute inset-0 animate-lightning bg-yellow-400/30" />
          </span>
          <div className="leading-none font-heading">
            <div className="text-white font-black text-lg tracking-tight uppercase">Vortex Ghost</div>
            <div className="text-[10px] tracking-[0.28em] text-zinc-500 font-mono uppercase">Severe Weather &middot; Research</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-yellow-400" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/apply" className="btn-primary" data-testid="nav-apply-btn">
            Apply <span className="ml-1">→</span>
          </Link>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((s) => !s)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-white/5" data-testid="nav-mobile-menu">
          <div className="container-vg py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`py-2 text-base font-medium ${
                  loc.pathname === l.to ? "text-yellow-400" : "text-zinc-300"
                }`}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ))}
            <Link to="/apply" onClick={() => setOpen(false)} className="btn-primary mt-2 justify-center">
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
